import React from 'react';
export interface IDisplayLabelProps extends React.HTMLAttributes<HTMLElement> {
  text: string;
  classNames?: string;
}

export const DisplayLabel = (props: IDisplayLabelProps) => {
  const { classNames, ...rest } = props;
  return (
    <label {...rest} className={`${classNames} display-label`}>
      {props.text}
    </label>
  );
};
